import styled from '@emotion/styled';
import { Tooltip, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const Container = styled.span`
  border-bottom: 1px dashed ${tokens.color.ui_border};

  :hover {
    border-bottom: 1px solid ${tokens.color.ui_border_alt};
  }
`;

export const NPSTag = ({ append }: { append?: string }): JSX.Element => {
  const { t } = useTranslation('feedback');
  return (
    <Tooltip text={t('results.nps-view-mode.tooltip-nps-text')}>
      <Container>
        {t('survey.question-types.nps')}
        {append}
      </Container>
    </Tooltip>
  );
};
